import { call, put, delay, take, select } from '@redux-saga/core/effects';
import { authApiClient, svpApiProxyClient } from 'services';
import authToken from 'models/authToken';
import { getFullUsernameFromEmail } from 'lib/email';
import { handleClientError } from 'services/client';
import { initDatadog } from 'services/datadog';
import { setEmailInLocalStorage } from 'store/auth/helpers';
import { aclFetch } from 'store/acl/actions';
import { hasToken } from './selectors';
import { ACCESS_TOKEN_LOADED, accessTokenLoaded, authorizationFailed } from './actions';

export function* loadAccessToken() {
    let accessToken = authToken.get();
    const isTokenValid = yield select(hasToken);

    if (authToken.isExpired() || !isTokenValid) {
        const rawAccessToken = yield call(authApiClient.fetchToken);
        accessToken = {
            raw: rawAccessToken,
            ...authToken.parse(rawAccessToken),
        };
        authToken.store(accessToken);
    }

    setEmailInLocalStorage(accessToken?.sub);
    yield call(initDatadog, getFullUsernameFromEmail(accessToken?.sub || ''));
    yield put(accessTokenLoaded(accessToken));
}

export function* authorize() {
    svpApiProxyClient.addEventListener('error', (event) => handleClientError(event, [401, 403]));

    try {
        while (true) {
            yield call(loadAccessToken);
            yield delay(authToken.expiresIn());
        }
    } catch {
        yield put(authorizationFailed());
    }
}

export function* fetchAcl() {
    yield take(ACCESS_TOKEN_LOADED);
    yield put(aclFetch());
}

export default [authorize(), fetchAcl()];
